module.exports = __webpack_public_path__ + "static/media/babel.65932304.svg";